/**
 * Sync with design-system.constants.scss
 */
export const ANIMATION_DURATION = 250;
export const BASE_FONT_SIZE = 10;
